<div class="ml-l">

<h2 >Abonnement {{ data['type'].label }}</h2>

  <p class="mb-m">Geben Sie eine oder mehrere Kontaktdaten an.</p>

  <form [formGroup]="communicationForm">

    <div formArrayName="emails">
      @for (item of communicationForm.get('emails').controls; track item; let i = $index) {
        <div class="d-flex aic mb-l" [formGroupName]="i">
          <mat-icon fontSet="material-symbols-outlined" class="mr-s" aria-hidden="false">mail</mat-icon>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>E-Mail Adresse</mat-label>
            <input matInput formControlName="email" placeholder="max@muster.de">
            <mat-error>Bitte Eingabe prüfen</mat-error>
          </mat-form-field>
          @if (communicationForm.get('emails').controls.length > 1) {
            <button type="button" mat-icon-button (click)="removeEmail(i)" aria-label="E-Mail entfernen">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" color="warn">delete_outline</mat-icon>
            </button>
          }
        </div>
      }
      <button type="button" mat-button color="primary" (click)="addEmail()">
        <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">add</mat-icon>
        Weitere E-Mail hinzufügen
      </button>
    </div>

    <mat-divider class="m-l"></mat-divider>

    <div formArrayName="phoneNumbers">
      @for (item of communicationForm.get('phoneNumbers').controls; track item; let i = $index) {
        <div class="d-flex aic mb-l" [formGroupName]="i">
          <mat-icon fontSet="material-symbols-outlined" class="mr-s" aria-hidden="false">sms</mat-icon>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Mobilfunknummer</mat-label>
            <input matInput formControlName="mobile" placeholder="01xxxxxxxxxx">
            <!--
                            <mat-hint>z. B. 01xxxxxxxx oder +491xxxxxxxxxx</mat-hint>
            -->
            <mat-error>Bitte Eingabe prüfen</mat-error>
          </mat-form-field>
          @if (communicationForm.get('phoneNumbers').controls.length > 1) {
            <button type="button" mat-icon-button (click)="removeMobile(i)" aria-label="Nummer entfernen">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" color="warn">delete_outline</mat-icon>
            </button>
          }
        </div>
      }
      <button type="button" mat-button color="primary" (click)="addMobile()">
        <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">add</mat-icon>
        Weitere Nummer hinzufügen
      </button>
    </div>

  </form>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="onCancel()">Abbrechen</button>
    <button mat-flat-button color="primary" type="submit"
            [disabled]="!communicationForm.valid"
            (click)="onSubmit()">
      Speichern
    </button>
  </mat-dialog-actions>
</div>
